import React from 'react'
import { IconsProps } from 'msp-integrations'

const AIcon = (props: IconsProps) => {
  return (
    <svg
      {...props}
      width={props?.width || '78'}
      height={props?.height || '83'}
      viewBox='0 0 360 344'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g transform='translate(0,344) scale(0.1,-0.1)'>
        <path d='M1420 3313 c-29 -71 -85 -207 -125 -304 l-72 -175 19 -50 c11 -27 213 -522 448 -1100 236 -578 439 -1087 451 -1130 17 -58 23 -108 23 -184 1 -94 -2 -110 -24 -150 -27 -48 -87 -90 -132 -90 -49 0 -58 -9 -58 -56 l0 -44 651 0 650 0 -3 47 -3 48 -55 8 c-158 22 -296 139 -399 337 -21 41 -296 705 -611 1475 -315 770 -581 1421 -592 1448 -20 47 -21 47 -68 47 l-48 0 -52 -127z' />
        <path d='M308 791 c-76 -25 -115 -50 -174 -113 -95 -100 -134 -225 -133 -418 1 -148 15 -210 51 -228 43 -20 230 -34 312 -23 241 34 398 162 436 356 22 113 -20 246 -105 330 -98 98 -259 139 -387 96z' />
        <path d='M3024 796 c-94 -41 -119 -183 -45 -257 84 -84 227 -47 261 68 39 130 -91 243 -216 189z m151 -49 c62 -62 55 -158 -14 -204 -70 -47 -156 -19 -186 61 -15 40 -16 50 -4 88 18 55 65 88 126 88 38 0 51 -6 78 -33z' />
        <path d='M3030 650 c0 -64 3 -80 15 -80 10 0 15 10 15 30 0 22 5 30 18 30 10 0 26 -13 35 -30 10 -16 25 -30 33 -30 19 0 18 7 -6 37 l-20 26 20 14 c26 18 26 59 1 73 -11 5 -40 10 -65 10 l-46 0 0 -80z m98 33 c3 -20 -1 -23 -32 -23 -32 0 -36 3 -36 26 0 23 3 25 33 22 24 -2 33 -8 35 -25z' />
      </g>
    </svg>
  )
}

export default AIcon
